import {memo} from 'react';

import type {SVGProps} from 'react';

export const CelebrationIcon = memo(function CelebrationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={80}
      height={80}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M8 71.75L22.9375 35.75C35.4375 39 40.75 44.3125 44 56.8125L8 71.75Z"
          fill="white"
        />
        <path
          d="M8 71.75L22.9375 35.75C35.4375 39 40.75 44.3125 44 56.8125L8 71.75Z"
          fill="white"
        />
        <path
          d="M36.9375 42.8122C26.375 34.3122 15.4375 54.7497 10.5625 65.5622L8 71.7497L44 56.8122C42.375 50.5622 40.25 46.1247 36.9375 42.8122Z"
          fill="#FCF09D"
        />
        <path
          d="M41.6875 50L8.75 70L8 71.75L44 56.8125C43.3125 54.25 42.5625 52 41.6875 50Z"
          fill="#F9B040"
        />
        <path
          d="M7.99993 73.6247C7.49993 73.6247 7.06243 73.4372 6.68743 73.0622C6.12493 72.4997 5.99993 71.7497 6.31243 70.9997L18.4999 41.6247C18.8749 40.6872 19.9999 40.1872 20.9374 40.6247C21.8749 40.9997 22.3749 42.1247 21.9374 43.0622L11.4999 68.2497L41.7499 55.6872C38.9374 47.5622 30.6249 39.6247 22.4999 37.5622C21.4999 37.3122 20.8749 36.2497 21.1249 35.2497C21.3749 34.2497 22.4374 33.6247 23.4374 33.8747C33.4374 36.4372 43.2499 46.3122 45.8124 56.2497C46.0624 57.1247 45.5624 58.1247 44.6874 58.4372L8.74993 73.4997C8.49993 73.6247 8.24993 73.6247 7.99993 73.6247ZM39.6874 34.9997C39.3749 34.9997 39.1249 34.9372 38.8749 34.8122C37.9374 34.3747 37.5624 33.2497 38.0624 32.3122C41.4374 25.6247 41.4374 17.6872 38.0624 10.9997C37.6249 10.0622 37.9999 8.93722 38.8749 8.49972C39.8124 8.06222 40.9374 8.43722 41.3749 9.31222C45.2499 17.0622 45.2499 26.2497 41.3749 33.9997C41.0624 34.6247 40.3749 34.9997 39.6874 34.9997ZM46.6874 41.9372C45.9999 41.9372 45.3124 41.5622 44.9999 40.8747C44.5624 39.9372 44.9374 38.8122 45.8124 38.3747C53.5624 34.4997 62.7499 34.4997 70.4999 38.3747C71.4374 38.8122 71.8124 39.9372 71.3124 40.8747C70.8749 41.8122 69.7499 42.1872 68.8124 41.6872C62.1249 38.3747 54.1874 38.3747 47.4999 41.6872C47.2499 41.8747 46.9374 41.9372 46.6874 41.9372ZM31.4999 30.3122C30.4999 30.3122 29.6874 29.5622 29.6249 28.5622C29.4999 26.9372 28.8124 25.4372 27.6874 24.3122C26.9374 23.5622 26.9374 22.3747 27.6874 21.6872C28.4374 20.9372 29.6249 20.9372 30.3124 21.6872C32.0624 23.4372 33.1874 25.8122 33.3749 28.3122C33.4374 29.3747 32.6874 30.2497 31.6249 30.3122C31.5624 30.3122 31.5624 30.3122 31.4999 30.3122Z"
          fill="#444B54"
        />
        <path
          d="M21.5 20C20.4375 20 19.625 19.1875 19.625 18.125C19.625 17.0625 20.4375 16.25 21.5 16.25C22.5625 16.25 23.375 17.0625 23.375 18.125C23.375 19.1875 22.5625 20 21.5 20Z"
          fill="#659EC9"
        />
        <path
          d="M57.75 60.6875C56.6875 60.6875 55.875 59.875 55.875 58.8125C55.875 57.75 56.6875 56.9375 57.75 56.9375C58.8125 56.9375 59.625 57.75 59.625 58.8125C59.625 59.8125 58.8125 60.6875 57.75 60.6875Z"
          fill="#F9B040"
        />
        <path
          d="M51.125 17.8125C50.0625 17.8125 49.25 17 49.25 15.9375C49.25 14.875 50.0625 14.0625 51.125 14.0625C52.1875 14.0625 53 14.875 53 15.9375C53 17 52.125 17.8125 51.125 17.8125Z"
          fill="#FF697B"
        />
        <path
          d="M35.625 22.625C34.5625 22.625 33.75 21.8125 33.75 20.75C33.75 19.6875 34.5625 18.875 35.625 18.875C36.6875 18.875 37.5 19.6875 37.5 20.75C37.5 21.8125 36.6875 22.625 35.625 22.625Z"
          fill="#8FE5B5"
        />
        <path
          d="M49.8125 34.125C48.75 34.125 47.9375 33.3125 47.9375 32.25C47.9375 31.1875 48.75 30.375 49.8125 30.375C50.875 30.375 51.6875 31.1875 51.6875 32.25C51.6875 33.3125 50.8125 34.125 49.8125 34.125Z"
          fill="#444B54"
        />
        <path
          d="M59.9375 31.0625C58.875 31.0625 58.0625 30.25 58.0625 29.1875C58.0625 28.125 58.875 27.3125 59.9375 27.3125C61 27.3125 61.8125 28.125 61.8125 29.1875C61.8125 30.25 61 31.0625 59.9375 31.0625Z"
          fill="#06A18C"
        />
        <path
          d="M70.125 50.0625C69.0625 50.0625 68.25 49.25 68.25 48.1875C68.25 47.125 69.0625 46.3125 70.125 46.3125C71.1875 46.3125 72 47.125 72 48.1875C72 49.1875 71.1875 50.0625 70.125 50.0625Z"
          fill="#F967F9"
        />
        <path
          d="M56.8127 52.6247C56.3127 52.6247 55.8752 52.4372 55.5002 52.0622C54.3752 50.9372 52.8752 50.2497 51.2502 50.1247C50.1877 50.0622 49.4377 49.1247 49.5002 48.1247C49.5627 47.0622 50.5002 46.3122 51.5002 46.3747C54.0002 46.5622 56.3752 47.6247 58.1252 49.4372C58.8752 50.1872 58.8752 51.3747 58.1252 52.0622C57.7502 52.4372 57.2502 52.6247 56.8127 52.6247Z"
          fill="#444B54"
        />
      </g>
    </svg>
  );
});
